import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/Admintestimonials.module.scss";
const baseURL = process.env.REACT_APP_BASE_URL;

const Admintestimonials = () => {
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    designation: "",
    feedback: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {
      name: formData.name.trim() || "N/A",
      location: formData.location.trim() || "N/A",
      designation: formData.designation.trim() || "N/A",
      feedback: formData.feedback.trim() || "No feedback provided",
    };
    try {
      await axios.post(`${baseURL}/api/testimonials`, dataToSend);
      setMessage("✅ Testimonial added successfully!");
      setFormData({ name: "", location: "", designation: "", feedback: "" });
    } catch (err) {
      setMessage("❌ Error adding testimonial");
      console.error(err);
    }
  };

  return (
    <div className={Style.formContainer}>
      <h2>Add Testimonial</h2>
      <form onSubmit={handleSubmit} className={Style.testimonialForm}>
        <input
          type="text"
          name="name"
          placeholder="Client Name"
          value={formData.name}
          onChange={handleChange}
        />
        <input
          type="text"
          name="designation"
          placeholder="Client Designation"
          value={formData.designation}
          onChange={handleChange}
        />
        <input
          type="text"
          name="location"
          placeholder="Client Location"
          value={formData.location}
          onChange={handleChange}
        />
        <textarea
          name="feedback"
          placeholder="Client Feedback"
          value={formData.feedback}
          onChange={handleChange}
        ></textarea>
        <button type="submit">Submit</button>
      </form>
      {message && <p className={Style.message}>{message}</p>}
    </div>
  );
};

export default Admintestimonials;
